import React from 'react';
import { Button, Form, Input, Space } from 'antd';

import { FormFieldLabel } from './FormFieldLabel';
import { FormInputProps, StyledFormItem } from './FormInput';

export const FormLinkInput: React.FC<FormInputProps> = ({ name, label, required, disabled }) => {
  const link = Form.useWatch(name);
  return (
    <StyledFormItem
      style={{ marginBottom: '5px' }}
      label={<FormFieldLabel required={required}>{label}</FormFieldLabel>}
    >
      <Space.Compact style={{ width: '100%' }}>
        <Form.Item name={name} noStyle>
          <Input disabled={disabled} />
        </Form.Item>
        <a href={link} target="_blank" rel="noreferrer">
          <Button type="primary">Open</Button>
        </a>
      </Space.Compact>
    </StyledFormItem>
  );
};
